const headRowsManagementBackups = {
  file: 'Arquivo',
  createdAt: 'Data',
  createdBy: 'Autor',
  size: 'Tamanho',
  type: 'Tipo',
  ingested: 'Consumido',
  download: 'Download',
  edit: 'Editar'
};

export default headRowsManagementBackups;
